/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ICocReadUserApproverStatusData } from './coc-read-user-approver-status.data';
import { ICocReadUserApproverStatusProps } from './coc-read-user-approver-status.props.autogenerated';

export interface ICocReadUserApproverStatusViewProps extends ICocReadUserApproverStatusProps<ICocReadUserApproverStatusData> {
    showLoader: boolean;
}
export interface ICocReadUserApproverStatusViewState {
    showLoader: boolean;
}
/**
 *
 * CocReadUserApproverStatus component
 * @extends {React.PureComponent<ICocReadUserApproverStatusProps<ICocReadUserApproverStatusData>>}
 */
class CocReadUserApproverStatus extends React.PureComponent<
    ICocReadUserApproverStatusProps<ICocReadUserApproverStatusData>,
    ICocReadUserApproverStatusViewState
> {
    private isAllowed: boolean;
    constructor(props: ICocReadUserApproverStatusViewProps) {
        super(props);
        const { isEditor, isPreview } = this.props.context.request.params;
        this.isAllowed = isEditor || isPreview;
        this.state = {
            showLoader: !this.isAllowed
        };
    }
    public componentDidMount(): void {
        const { isAuthenticated, signInUrl } = this.props.context.request.user;
        const channelRestriction = this.props.context.request.channel?.ExtensionProperties?.find(x => x?.Key === 'ApproverStatus');
        const { customerInformation } = this.props.data;
        const { redirectURL } = this.props.config;
        // If value is false then channel is restricted
        if (!this.isAllowed && channelRestriction && !channelRestriction.Value?.BooleanValue) {
            if (!isAuthenticated) {
                window.location.assign(signInUrl || '');
                return;
            }
            const approverStatus = customerInformation.result?.ExtensionProperties?.find(x => x.Key?.toLowerCase() === 'approverstatus');
            if (approverStatus && !approverStatus?.Value?.BooleanValue) {
                // redirect the user to the desired page (our another custom module)
                redirectURL?.linkUrl.destinationUrl && window.location.assign(redirectURL?.linkUrl.destinationUrl);
                return;
            }
        }
        this.setState({ showLoader: false });
    }
    public render(): JSX.Element | null {
        const viewProps: ICocReadUserApproverStatusViewProps = {
            ...this.props,
            showLoader: this.state.showLoader
        };
        return this.props.renderView(viewProps);
    }
}

export default CocReadUserApproverStatus;
